import React, { useRef, useState } from 'react';
import '../assets/styles/Contact.scss';
import emailjs from '@emailjs/browser';

import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';

function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [messageError, setMessageError] = useState(false);

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const form = useRef<HTMLFormElement>(null);

  const sendEmail = async (e: React.FormEvent) => {
    e.preventDefault();

    // Reset states
    setNameError(false);
    setEmailError(false);
    setMessageError(false);
    setSuccessMessage('');
    setErrorMessage('');

    // Basic validation
    const isNameValid = name.trim() !== '';
    const isEmailValid = email.trim() !== '';
    const isMessageValid = message.trim() !== '';

    setNameError(!isNameValid);
    setEmailError(!isEmailValid);
    setMessageError(!isMessageValid);

    if (!isNameValid || !isEmailValid || !isMessageValid) return;

    if (form.current) {
      try {
        await emailjs.sendForm(
          'service_kb7raom',
          'template_3ya3syq',
          form.current,
          'pOsudsGb9Ui-XErGg'
        );

        setName('');
        setEmail('');
        setMessage('');
        setSuccessMessage('Your message has been sent successfully!');
      } catch (error) {
        console.error('EmailJS Error:', error);
        setErrorMessage('Failed to send message. Please try again later.');
      }
    }
  };

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1 style={{ fontFamily: 'Uzicute' }}>Contact Me</h1>
          <p style={{ fontFamily: 'Times New Roman' }}>
            Got a project waiting to be realized? Let's collaborate and make it happen!
          </p>

          <form
            ref={form}
            className="contact-form"
            onSubmit={sendEmail}
            noValidate
            autoComplete="off"
          >
            <div className="form-flex">
              <TextField
                required
                label="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                error={nameError}
                helperText={nameError ? 'Please enter your name' : ''}
                name="user_name"
                fullWidth
              />

              <TextField
                required
                label="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={emailError}
                helperText={emailError ? 'Please enter a valid email' : ''}
                name="user_email"
                fullWidth
              />
            </div>

            <TextField
              required
              label="Message"
              multiline
              rows={6}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              error={messageError}
              helperText={messageError ? 'Please enter your message' : ''}
              name="message"
              fullWidth
            />

            <Button variant="contained" endIcon={<SendIcon />} type="submit">
              Send
            </Button>
          </form>

          {successMessage && <p className="success-message">{successMessage}</p>}
          {errorMessage && <p className="error-message">{errorMessage}</p>}
        </div>
      </div>
    </div>
  );
}

export default Contact;
